// 12×12 pixel sprite grids — one char = one pixel, mapped via PALETTE.
// Lifted from the approved /tmp/badge-mockup.html.

export const PALETTE = {
  '.': null,
  R: '#ff3333', O: '#ff8800', Y: '#ffff00', W: '#ffffff',
  G: '#39ff14', B: '#19b8ff', P: '#ff00ff', g: '#ffcc00',
  A: '#9aa0a6', K: '#2a2a3a',
};

export const SPRITES = {
  TEN: [
    '............',
    '.WW...WWWW..',
    'WWW..WW..WW.',
    '.WW..WW..WW.',
    '.WW..WW..WW.',
    '.WW..WW..WW.',
    '.WW..WW..WW.',
    '.WW..WW..WW.',
    'WWWW..WWWW..',
    '............',
    '.BBBBBBBBBB.',
    '............',
  ],
  TWENTYFIVE: [
    '............',
    'WWWW..WWWW..',
    '...W..W.....',
    '...W..W.....',
    'WWWW..WWWW..',
    'W........W..',
    'W........W..',
    'WWWW..WWWW..',
    '............',
    '.BBBBBBBBB..',
    '............',
    '............',
  ],
  FIFTY: [
    '............',
    'WWWW..WWWW..',
    'W.....W..W..',
    'W.....W..W..',
    'WWWW..W..W..',
    '...W..W..W..',
    '...W..W..W..',
    'WWWW..WWWW..',
    '............',
    '.BBBBBBBBB..',
    '............',
    '............',
  ],
  HUNDRED: [
    '............',
    '.W..WWW.WWW.',
    'WW..W.W.W.W.',
    '.W..W.W.W.W.',
    '.W..W.W.W.W.',
    '.W..W.W.W.W.',
    '.W..WWW.WWW.',
    '............',
    'RRRRRRRRRR..',
    '.RRRRRRRRRR.',
    '............',
    '............',
  ],
  TWOHUNDRED: [
    '............',
    'WWW.WWW.WWW.',
    '..W.W.W.W.W.',
    '..W.W.W.W.W.',
    'WWW.W.W.W.W.',
    'W...W.W.W.W.',
    'W...W.W.W.W.',
    'WWW.WWW.WWW.',
    '............',
    'RRRRRRRRRRR.',
    '.RRRRRRRRRRR',
    '............',
  ],
  CHECKS: [
    '............',
    '.GG.GG.GG...',
    '.GG.GG.GG...',
    '............',
    '.GG.GG.GG...',
    '.GG.GG.GG...',
    '............',
    '.GG.GG.GG...',
    '.GG.GG.GG...',
    '............',
    '............',
    '............',
  ],
  BARCHART: [
    '..R.........',
    '..R.........',
    '..R.........',
    '..R.........',
    '..R.........',
    '..R.........',
    '..R.........',
    '..R..B......',
    '..R..B..B...',
    '..R..B..B.B.',
    '.AAAAAAAAAAA',
    '............',
  ],
  MEAT: [
    '............',
    '.......OO...',
    '......OOOO..',
    '.....OOOOO..',
    '....OOOOOO..',
    '...OOOOOO...',
    '..OOOOOO....',
    '..OOOOO.....',
    '..WWW.......',
    '.WW.WW......',
    '.W...W......',
    '............',
  ],
  BOWL: [
    '............',
    '............',
    '............',
    '............',
    '.A........A.',
    '.AA......AA.',
    '..AA....AA..',
    '...AAAAAA...',
    '....AAAA....',
    '............',
    '............',
    '............',
  ],
  THREEBALLS: [
    '............',
    '............',
    '............',
    '............',
    '.WWW.WWW.WWW',
    '.WRW.WRW.WRW',
    '.WWW.WWW.WWW',
    '............',
    '............',
    '............',
    '............',
    '............',
  ],
  CYCLE: [
    '............',
    '...BBBBBB...',
    '..BB....BB..',
    '.BB......BB.',
    '.BB......BB.',
    '.BB......BB.',
    '.BB......BB.',
    '..BB....BB..',
    '...BBBBBB.B.',
    '..........BB',
    '.........BBB',
    '............',
  ],
  REACH: [
    '............',
    '..A.A.A.A...',
    '..A.A.A.A...',
    '..AAAAAAA...',
    '..AAAAAAA...',
    'A.AAAAAAA...',
    'AAAAAAAAA...',
    '.AAAAAAAA...',
    '..AAAAAAA...',
    '...AAAAA....',
    '............',
    '............',
  ],
  ELEVEN: [
    '....Y.......',
    '...YYY......',
    '..Y.Y.Y.....',
    '....Y.......',
    '............',
    '.WW....WW...',
    'WWW...WWW...',
    '.WW....WW...',
    '.WW....WW...',
    '.WW....WW...',
    'WWWW..WWWW..',
    '............',
  ],
  MEDIC: [
    '............',
    '....RR......',
    '....RR......',
    '..RRRRRR....',
    '..RRRRRR....',
    '....RR......',
    '....RR......',
    '............',
    '.......g....',
    '......gg....',
    '.....gg.....',
    '....gg......',
  ],
  BENCH: [
    '....Y.Y.Y...',
    '....YYYYY...',
    '............',
    '.OOOOOOOOOO.',
    '.OOOOOOOOOO.',
    '.O........O.',
    '.O........O.',
    '.O........O.',
    '............',
    '............',
    '............',
    '............',
  ],
  FLAME: [
    '.....R......',
    '....RR......',
    '....ROR.....',
    '...ROOR.....',
    '...ROYOR....',
    '..ROYYOR....',
    '..ROYYYOR...',
    '.ROYYWYOR...',
    '.ROYWWYYOR..',
    '.ROYWWWYOR..',
    '..ROYWYOR...',
    '...ROOOR....',
  ],
  SKULL: [
    '...WWWWWW...',
    '..WWWWWWWW..',
    '.WWWWWWWWWW.',
    '.WWWWWWWWWW.',
    '.WWKKWWKKWW.',
    '.WWKKWWKKWW.',
    '.WWWWWWWWWW.',
    '.WWWWKKWWWW.',
    '..WWWWWWWW..',
    '...WWWWWW...',
    '...WKWWKW...',
    '...WKWWKW...',
  ],
  THERMO: [
    '.....WW.....',
    '.....WR.....',
    '.....WR.....',
    '.....WR.....',
    '.....WR.....',
    '.....WR.....',
    '.....WR.....',
    '....WRRW....',
    '...WRRRRW...',
    '...WRRRRW...',
    '....WRRW....',
    '.....WW.....',
  ],
  CROWN: [
    '............',
    '.Y...YY...Y.',
    '.YY..YY..YY.',
    '.YY.YYYY.YY.',
    '.YYYYYYYYYY.',
    '.YYYYYYYYYY.',
    '.YPYYPPYYPY.',
    '.YYYYYYYYYY.',
    '.YYYYYYYYYY.',
    '..YYYYYYYY..',
    '............',
    '............',
  ],
  STAIRS: [
    '..........GG',
    '........GGGG',
    '........GGGG',
    '......GGGGGG',
    '......GGGGGG',
    '....GGGGGGGG',
    '....GGGGGGGG',
    '..GGGGGGGGGG',
    '..GGGGGGGGGG',
    'GGGGGGGGGGGG',
    'GGGGGGGGGGGG',
    '............',
  ],
  SHOVEL: [
    '.....gg.....',
    '.....gg.....',
    '.....gg.....',
    '.....gg.....',
    '.....gg.....',
    '.....gg.....',
    '....AAAA....',
    '...AAAAAA...',
    '...AAAAAA...',
    '...AAAAAA...',
    '....AAAA....',
    '............',
  ],
  MASK: [
    '............',
    '..AAAAAAAA..',
    '.AAKKKKKKAA.',
    '.AKAAKKAAKA.',
    '.AKAAKKAAKA.',
    '.AAKKKKKKAA.',
    '.AKKAAAAKKA.',
    '.AKKAAAAKKA.',
    '.AAKKKKKKAA.',
    '..AAAAAAAA..',
    '...AAAAAA...',
    '............',
  ],
  DIAMOND: [
    '............',
    '.....GG.....',
    '....GGGG....',
    '...GG..GG...',
    '..GG....GG..',
    '.GG......GG.',
    '.GG......GG.',
    '..GG....GG..',
    '...GG..GG...',
    '....GGGG....',
    '.....GG.....',
    '............',
  ],
  BAT: [
    '..........gg',
    '.........ggg',
    '........ggg.',
    '.......ggg..',
    '......ggg...',
    '.....ggg....',
    '....ggg.....',
    '...ggg......',
    '..Ogg.......',
    '.OOg........',
    '.OO.........',
    '............',
  ],
  TOMBSTONE: [
    '............',
    '....AAAA....',
    '...AAAAAA...',
    '..AAAAAAAA..',
    '..AAKAAKAA..',
    '..AAKKKKAA..',
    '..AAKAAKAA..',
    '..AAAAAAAA..',
    '..AAAAAAAA..',
    '..AAAAAAAA..',
    '.GGGGGGGGGG.',
    'GGGGGGGGGGGG',
  ],
  SADTROPHY: [
    '............',
    '...AAAAAA...',
    '...A....A...',
    '...A....A...',
    '...AAAAAA...',
    '....AAAA....',
    '.....AA.....',
    '.....AA.....',
    '.....AA.....',
    '....AAAA....',
    '...AAAAAA...',
    '............',
  ],
  TROPHY: [
    'gg.gggggg.gg',
    'g.gggggggg.g',
    'g.ggYggYgg.g',
    'g.gggggggg.g',
    'gg.gggggg.gg',
    '...gggggg...',
    '....gggg....',
    '.....gg.....',
    '.....gg.....',
    '....gggg....',
    '...gggggg...',
    '..gggggggg..',
  ],
};
